import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import BtnTable from '../../../components/buttons/BtnTable';
import HeaderSimple from '../../../components/headers/catalogs/HeaderSimple';
import MainLoader from '../../../components/Loaders/MainLoader';
import Error from '../../../components/errors/Error';
import UploadFileModal from '../../../components/modals/UploadFileModal';
//SLICE
import { getLevelsThunk, deleteLevelThunk } from '../../../store/slices/catalogs/levels.slice';
import { uploadLevelExcelData } from '../../../store/slices/catalogs/uploadLevelData.slice';
import { resetState } from '../../../store/slices/catalogs/uploadLevelData.slice';
import BtnAdd from '../../../components/buttons/BtnAdd';

const LevelList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, message, error } = useSelector(state => state.levels);
    const { success, process, error_message } = useSelector(state => state.data_levels_excel);
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        dispatch(getLevelsThunk());
    }, []);

    if (message === "Registro eliminado correctamente") {
        dispatch(getLevelsThunk());
    }

    const handledeleteUser = (id) => {
        dispatch(deleteLevelThunk(id));
    };

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <div className='flex w-full items-center justify-between p-2 border mb-2 shadow-sm'>
                        <HeaderSimple title={t("Secciones")} to={`/panel/sections/section_new`} />
                        <div className='flex gap-2 items-center'>
                            <BtnAdd to={`/panel/sections/section_new`} />
                            <UploadFileModal
                                title={'Subir niveles en bloque'}
                                funtion={uploadLevelExcelData}
                                message={success}
                                error={error_message}
                                process={process}
                                resetState={resetState}
                                getItems={getLevelsThunk} />
                        </div>
                    </div>
                    <div className="h-[90%] flex flex-col  rounded overflow-hidden">
                        <div className="overflow-y-auto flex-1 contenedor">
                            <table className="min-w-full table-zebra table-fixed border-collapse text-[13px] text-left">
                                <thead className="sticky top-0 bg-white">
                                    <tr className='text-left h-[50px] bg-p-orange/80 text-white'>
                                        <th className='px-2'>{t("Nombre")}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items?.map((item) => (
                                        <tr className='h-[50px]' key={item.id}>
                                            <td className='px-2'>{item.name}</td>
                                            <td>
                                                <div className='flex gap-1 justify-end items-center h-[50px] p-2'>
                                                    <BtnTable action="edit" to={`/panel/courses/${item.id}`} />
                                                    <BtnTable title={t("¿Quieres eliminar este curso?")} action="delete" onclick={() => handledelete(item.id)} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="sticky bottom-0 z-10 bg-gray-100 text-gray-700">
                                    <tr>
                                        <td colSpan={5} className="text-right p-2">
                                            Total de registros:{" "}
                                            <span className="text-p-sky text-[18px]">{items?.length ?? 0}</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default LevelList;